import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import useMediaQuery from '@mui/material/useMediaQuery'
import * as React from 'react'
import { NextActionDate } from '../NextActionDate/NextActionDate'
import { entityNextActionDate } from '@user/components/Settings/EntityFormSettings/constants'
import { useData } from '../NextActionDate/hooks'
import { AddToPestPacToggle } from '../AddToPestPacToggle/AddToPestPacToggle'

type Props = {
  hideOptional: boolean
  activeAddToPestPac: boolean
}

export function TitleSection(props: Props) {
  const { hideOptional, activeAddToPestPac } = props

  const { showNextActionDate } = useData({
    fieldName: entityNextActionDate,
    hideOptional,
  })

  const isMobile = useMediaQuery('(max-width:900px)')

  return (
    <Grid container item>
      <Grid item xs alignContent="center" mb={2}>
        <Typography variant="h5" mt={2} noWrap>
          Add Lead
        </Typography>
      </Grid>
      {isMobile && activeAddToPestPac && (
        <Grid item alignContent="center">
          <AddToPestPacToggle />
        </Grid>
      )}
      {isMobile && showNextActionDate && (
        <Grid item xs={activeAddToPestPac ? 12 : 8} alignContent="center">
          <NextActionDate
            fieldName={entityNextActionDate}
            hideOptional={hideOptional}
          />
        </Grid>
      )}
    </Grid>
  )
}
